import { POSTHOG_APP_URL } from '@/config/config'

/** PostHog numbers group types in the order they were first seen; `identifyOrg`'s `org` came first. */
const ORG_GROUP_TYPE_INDEX = 0

/** This environment's PostHog project, or null where the page has none (development). */
function projectUrl(): string | null {
  const projectId = window.__CAI_CONFIG__?.posthogProjectId
  return projectId ? `${POSTHOG_APP_URL}/project/${projectId}` : null
}

/** A person's page, with their session replays; PostHog knows them by their account id. */
export function posthogPersonUrl(customUserId: string | null | undefined): string | null {
  const project = projectUrl()
  return project && customUserId ? `${project}/person/${encodeURIComponent(customUserId)}` : null
}

/** One browser session's replay. */
export function posthogReplayUrl(sessionId: string | null | undefined): string | null {
  const project = projectUrl()
  return project && sessionId ? `${project}/replay/${encodeURIComponent(sessionId)}` : null
}

/** An org's group page: everyone in it and what they did. */
export function posthogOrgUrl(orgId: string | null | undefined): string | null {
  const project = projectUrl()
  return project && orgId ? `${project}/groups/${ORG_GROUP_TYPE_INDEX}/${encodeURIComponent(orgId)}` : null
}
